import React from 'react';
import Stack1 from '@mui/material/Stack';
 import './Stack.css';
const Stack =({children})=>{
    return(
        <div className='stack' >
            {children}
        </div>
    )
}
export default Stack;